import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import AsyncConfirmModal from 'Components/ConfirmModal/AsyncConfirmModal';
import { noop } from 'Helpers/function';

export const UserSuspended = ({ isOpen, onAccept, onDecline, intl }) => {
    return (
        <AsyncConfirmModal
            isOpened={ isOpen }
            title={ intl.formatMessage({ id: 'account_suspended_title' }) }
            text={ intl.formatMessage({ id: 'account_suspended_text' }) }
            acceptText={ intl.formatMessage({ id: 'close' }) }
            declineText={ intl.formatMessage({ id: 'help' }) }
            onAccept={ onAccept }
            onDecline={ onDecline }
        />
    );
};

UserSuspended.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onAccept: PropTypes.func,
    onDecline: PropTypes.func,
    intl: PropTypes.shape({
        formatMessage: PropTypes.func.isRequired
    }).isRequired
};

UserSuspended.defaultProps = {
    isOpen: false,
    onAccept: noop,
    onDecline: noop
};

export default compose(
    injectIntl,
    React.memo
)(UserSuspended);
